// extracted by mini-css-extract-plugin
export default {"selectBox":"CustomSelect_selectBox__9sZO0","select":"CustomSelect_select__Bz5jl","active":"CustomSelect_active__SCKYL","viewList":"CustomSelect_viewList__IEyzc"};